import fileUploadFns from '@gef-ui/validation-functions/fileUpload';
import createValidationFn from '../../createValidationFn';
/**
 * Validate max file size for FileInput
 *
 * @documented
 * @category Fileupload
 * @import import { maxFileSize } from '@gef-ui/form-core/validations/validationFunctions/fileUpload'
 * @param {Object} input
 * @param {String} [input.fieldMessageKey=uploadHasError] - default message for field
 * @param {String} [input.fileMessageKey=wrongSize] - default message for file
 * @param {Number} [input.maxSize] - max size in bytes
 * @returns {String} errMessage
 *
 */ export const maxFileSize = createValidationFn(fileUploadFns.maxFileSize);
/**
 * Validate max file size for Dropzone
 *
 * @documented
 * @category Fileupload
 * @import import { maxFileSizeDropzone } from '@gef-ui/form-core/validations/validationFunctions/fileUpload'
 * @param {Object} input
 * @param {String} [input.fieldMessageKey=emptyError] - default message for field
 * @param {String} [input.fileMessageKey=wrongSizeDropzone] - default message for file
 * @param {Number} [input.maxSize] - max size in bytes
 * @returns {String} errMessage
 *
 */ export const maxFileSizeDropzone = createValidationFn(fileUploadFns.maxFileSize, {
    name: 'MAX_FILE_SIZE',
    defaultArgs: {
        fileMessageKey: 'wrongSizeDropzone',
        fieldMessageKey: 'emptyError'
    }
});
/**
 * Accepted file extensions for FileInput
 *
 * @documented
 * @category Fileupload
 * @import import { acceptedExtension } from '@gef-ui/form-core/validations/validationFunctions/fileUpload'
 * @param {Object} input
 * @param {String} [input.fieldMessageKey=uploadHasError] - default message for field
 * @param {String} [input.fileMessageKey=wrongExtension] - default message for file
 * @param {RegExp} [input.extension] - regexp for file extension
 * @returns {String} errMessage
 *
 */ export const acceptedExtension = createValidationFn(fileUploadFns.acceptedExtension);
/**
 * Accepted file extensions for Dropzone
 *
 * @documented
 * @category Fileupload
 * @import import { acceptedExtensionDropzone } from '@gef-ui/form-core/validations/validationFunctions/fileUpload'
 * @param {Object} input
 * @param {String} [input.fieldMessageKey=emptyError] - default message for field
 * @param {String} [input.fileMessageKey=wrongExtensionDropzone] - default message for file
 * @param {RegExp} [input.extension] - string (accept) for file extension
 * @returns {String} errMessage
 *
 */ export const acceptedExtensionDropzone = createValidationFn(fileUploadFns.acceptedExtension, {
    name: 'ACCEPT_FILE_EXTENSIONS',
    defaultArgs: {
        fileMessageKey: 'wrongExtensionDropzone',
        fieldMessageKey: 'emptyError'
    }
});
/**
 * Validate total max file size for FileInput
 *
 * @documented
 * @category FileUpload
 * @import import { totalMaxFileSize } from '@gef-ui/form-core/validations/validationFunctions/fileUpload'
 * @param {Object} input
 * @param {String} [input.fieldMessageKey=uploadTotalMaxSize] - default message for field
 * @param {Number} [input.maxSize] - max size in bytes
 * @returns {String} errMessage
 *
 */ export const totalMaxFileSize = createValidationFn(fileUploadFns.totalMaxFileSize, {
    name: 'TOTAL_MAX_FILE_SIZE'
});
/**
 * Validate total num of files for FileInput
 *
 * @documented
 * @category FileUpload
 * @import import { maxNumOfFiles } from '@gef-ui/form-core/validations/validationFunctions/fileUpload'
 * @param {Object} input
 * @param {String} [input.fieldMessageKey=uploadMaxNumOfFiles] - default message for field
 * @param {Number} [input.numOfFiles] - maximum number of files
 * @returns {String} errMessage
 *
 */ export const maxNumOfFiles = createValidationFn(fileUploadFns.maxNumOfFiles, {
    name: 'MAX_NUM_OF_FILES'
});
